import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import { createImageUrl } from '../../../lib/serum-imagecrop'
import PureComponent from '../../../lib/preact-pure-component'
import * as classNames from 'classnames'
import { isIe } from '../../../lib/isIe'
interface Props {
  polopolyId?: string
  polopolyIdVertical?: string
  fadeInFrom?: string
  fadeOutTo?: string
  altText?: string
  quality?: string
  photographer?: string
  style?: string
  active: boolean
  fadeClasses: string
}

interface State {
  style: any
}

export class Image extends PureComponent<Props, State> {
  timingIn: number
  timingOut: number
  delayIn: number
  constructor(props: Props) {
    super()
    if (props.style && props.style.indexOf('fastTransitionIn') > -1) {
      this.timingIn = 0.7
      this.delayIn = 0.5
    } else {
      this.delayIn = 1
      this.timingIn = 1
    }
    if (props.style && props.style.indexOf('fastTransitionOut') > -1) {
      this.timingOut = 0.7
      this.delayIn = 0.5
    } else {
      this.delayIn = 1
      this.timingOut = 1.2
    }
    if (props.fadeInFrom) {
      this.state = { style: { opacity: 0, transition: `opacity ${this.timingIn}s ease-out ${this.delayIn}` } }
    }
    if (props.fadeOutTo) {
      this.state = { style: { opacity: 1, transition: `opacity ${this.timingOut}s ease-in` } }
    }
  }

  componentDidMount() {
    if (this.props.fadeInFrom && this.props.active) {
      this.fadeIn()
    } else if (this.props.fadeOutTo && this.props.active) {
      this.setState({ style: { opacity: 1, transition: 'opacity 0s' } })
    }

    if (this.props.fadeOutTo && !this.props.active) {
      this.fadeOut()
    }
  }

  componentDidUpdate(prevProps: Props) {
    const toActive = !prevProps.active && this.props.active
    const fromActive = prevProps.active && !this.props.active
    const { fadeInFrom, fadeOutTo } = this.props

    if (fadeInFrom && toActive) {
      this.fadeIn()
    } else if (fadeOutTo && toActive) {
      this.setState({ style: { opacity: 1, transition: 'opacity 0s' } })
    }

    if (fadeOutTo && fromActive) {
      this.fadeOut()
    }
  }

  fadeIn = () => {
    const style = { opacity: 1, transition: `opacity ${this.timingIn}s ease-in ${this.delayIn}` }
    this.setState({ style })
  }

  fadeOut = () => {
    const style = { opacity: 0, transition: `opacity ${this.timingOut}s ease-out` }
    this.setState({ style })
  }

  createSrcSet = (polopolyId?: string, ratio?: string) => {
    if (polopolyId) {
      const supportedWidths = [450, 900, 1280, 1920, 2400]
      return supportedWidths
        .map(width => {
          const imageUrl = createImageUrl({ id: polopolyId, width, ratio, quality: 0.6 })
          return `${imageUrl} ${width}w`
        })
        .join(', ')
    }
  }

  getDefaultUrl = (polopolyId?: string) => {
    if (polopolyId) {
      return createImageUrl({
        id: polopolyId,
        width: 1600,
        ratio: undefined,
        quality: 0.6
      })
    }
  }

  getMobileSrcSet = (polopolyId?: string, polopolyIdVertical?: string) => {
    if (polopolyIdVertical) {
      return this.createSrcSet(polopolyIdVertical)
    } else if (polopolyId) {
      return this.createSrcSet(polopolyId, '3:4')
    }
  }

  render() {
    const { polopolyId, polopolyIdVertical, fadeInFrom, fadeOutTo, altText, quality } = this.props
    const isClient = typeof window !== 'undefined'
    const isFirstImage = this.props.style && this.props.style.indexOf('intro') > -1
    const isIE = isIe()
    let fadeInFromElement, fadeOutToElement

    if (isClient && !!fadeInFrom) {
      const fadeInFromDesktopSrcSet = this.createSrcSet(fadeInFrom)
      const fadeInFromMobileSrcSet = this.getMobileSrcSet(fadeInFrom)
      fadeInFromElement = (
        <div className={style.picture} aria-hidden="true">
          <picture>
            <source media="(min-aspect-ratio: 1/1)" type="image/jpeg" srcset={fadeInFromDesktopSrcSet} />
            <source srcset={fadeInFromMobileSrcSet} type="image/jpeg" />
            <img className={style.img} type="image/jpeg" alt={altText} />
          </picture>
        </div>
      )
    }

    if (isClient && !!fadeOutTo) {
      const fadeOutToDesktopSrcSet = this.createSrcSet(fadeOutTo)
      const fadeOutToMobileSrcSet = this.getMobileSrcSet(fadeOutTo)
      fadeOutToElement = (
        <div className={style.picture} aria-hidden="true">
          <picture>
            <source media="(min-aspect-ratio: 1/1)" type="image/jpeg" srcset={fadeOutToDesktopSrcSet} />
            <source srcset={fadeOutToMobileSrcSet} type="image/jpeg" />
            <img className={style.img} type="image/jpeg" alt={altText} />
          </picture>
        </div>
      )
    }

    if (isClient || isFirstImage) {
      const desktopSrcSetMain = this.createSrcSet(polopolyId)
      const mobileSrcSetMain = this.getMobileSrcSet(polopolyId, polopolyIdVertical)
      const classes = isClient
        ? classNames(style.img, { [style.ie]: isIE, [style.ieActive]: isIE && this.props.active })
        : style.img
      return (
        <div className={this.props.fadeClasses}>
          {!isIE && fadeInFromElement}
          {!isIE && fadeOutToElement}
          <div className={style.picture}>
            <picture>
              <source media="(min-aspect-ratio: 1/1)" type="image/jpeg" srcset={desktopSrcSetMain} />
              <source srcset={mobileSrcSetMain} type="image/jpeg" />
              <img
                className={classes}
                style={this.state.style}
                type="image/jpeg"
                alt={altText}
                src={isIE && this.getDefaultUrl(polopolyId)}
              />
            </picture>
          </div>
        </div>
      )
    }

    return null
  }
}
